import React, { useState } from 'react';
import { Menu, X, User } from 'lucide-react';
export function Navbar() {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const navLinks = ['HOME', 'ABOUT US', 'AGENDAS & MINUTES', 'AGENDA REQUESTS', 'NEWS', 'CALENDAR', 'COMMITTEES', 'CONTACT'];
  return <header className="sticky top-0 z-50 w-full bg-white shadow-md" data-id="element-218">
      {/* City of LA Top Bar */}
      <div className="bg-charcoal text-white text-xs py-1.5 px-4 md:px-8 flex justify-between items-center" data-id="element-219">
        <div className="flex items-center gap-2" data-id="element-220">
          <img src="https://upload.wikimedia.org/wikipedia/commons/thumb/6/69/Seal_of_Los_Angeles%2C_California.svg/1024px-Seal_of_Los_Angeles%2C_California.svg.png" alt="City of Los Angeles Seal" className="w-4 h-4" data-id="element-221" />
          <span data-id="element-222">An Official Website of the City of Los Angeles</span>
        </div>
        <div className="hidden md:flex gap-4" data-id="element-223">
          <a href="#" className="hover:text-sylmar transition-colors" data-id="element-224">
            City Services
          </a>
          <a href="#" className="hover:text-sylmar transition-colors" data-id="element-225">
            City Directory
          </a>
        </div>
      </div>

      {/* Main Header */}
      <div className="px-4 md:px-8 py-4 flex justify-between items-center" data-id="element-226">
        <a href="#" className="flex-shrink-0" data-id="element-227">
          <img src="https://cdn.magicpatterns.com/uploads/ifXuZUrDS4dUFiWt5hJfva/LOGO_OFICIAL_DE_CONCILIO_DE_SYLMAR_._VERDE.png" alt="Sylmar Neighborhood Council" className="h-16 md:h-20 object-contain" data-id="element-228" />
        </a>

        <div className="hidden lg:flex items-center gap-8" data-id="element-229">
          <div className="text-right text-sm text-charcoal-light" data-id="element-230">
            <p className="font-bold text-charcoal" data-id="element-231">(818) 833-8737</p>
            <p data-id="element-232">13521 Hubbard St.</p>
            <p data-id="element-233">Sylmar, CA 91342</p>
          </div>
          <button className="flex items-center gap-2 border-2 border-sylmar text-sylmar hover:bg-sylmar hover:text-white px-6 py-2 rounded-md font-bold transition-colors" data-id="element-234">
            <User className="w-4 h-4" data-id="element-235" />
            LOGIN
          </button>
        </div>

        {/* Mobile Menu Button */}
        <button className="lg:hidden p-2 text-charcoal hover:text-sylmar" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} data-id="element-236">
          {isMobileMenuOpen ? <X className="w-8 h-8" data-id="element-237" /> : <Menu className="w-8 h-8" data-id="element-238" />}
        </button>
      </div>

      {/* Desktop Navigation */}
      <nav className="hidden lg:block bg-sylmar-light border-t border-sylmar/10" data-id="element-239">
        <ul className="flex justify-center flex-wrap px-4" data-id="element-240">
          {navLinks.map((link, index) => <li key={index} data-id="element-241">
              <a href={`#${link.toLowerCase().replace(/\s+/g, '-')}`} className="block px-4 py-3 text-sm font-bold text-charcoal hover:text-sylmar hover:bg-white transition-colors border-b-2 border-transparent hover:border-sylmar" data-id="element-242">
                {link}
              </a>
            </li>)}
        </ul>
      </nav>

      {/* Mobile Navigation */}
      {isMobileMenuOpen && <nav className="lg:hidden bg-white border-t border-gray-100 absolute w-full shadow-xl" data-id="element-243">
          <ul className="flex flex-col py-2" data-id="element-244">
            {navLinks.map((link, index) => <li key={index} data-id="element-245">
                <a href={`#${link.toLowerCase().replace(/\s+/g, '-')}`} className="block px-6 py-3 text-sm font-bold text-charcoal hover:text-sylmar hover:bg-sylmar-light transition-colors" onClick={() => setIsMobileMenuOpen(false)} data-id="element-246">
                  {link}
                </a>
              </li>)}
            <li className="px-6 py-4 border-t border-gray-100 mt-2" data-id="element-247">
              <button className="w-full flex justify-center items-center gap-2 bg-sylmar text-white px-6 py-3 rounded-md font-bold transition-colors" data-id="element-248">
                <User className="w-4 h-4" data-id="element-249" />
                LOGIN
              </button>
            </li>
          </ul>
        </nav>}
    </header>;
}